import gql from 'graphql-tag';
import { opportunityEconomyFragment } from './fragments';

/*
*
*/
export const opportunityEconomies = gql`
  query opportunityEconomies($where: OpportunityEconomyWhereInput, $orderBy: OpportunityEconomyOrderByInput, $skip: Int, $after: String, $before: String, $first: Int, $last: Int) {
    opportunityEconomies(where: $where, orderBy: $orderBy, skip: $skip, after: $after, before: $before, first: $first, last: $last) ${opportunityEconomyFragment}
  }
`;
